import validator from "email-validator";

export const validateEmail = (email: string): boolean =>
  validator.validate(email);

// Mirrors the backend's PERSON_NAME_DISPLAY_REGEX: words of unicode
// letters/combining marks, optionally joined by a space, apostrophe
// (straight or curly), or dash.
const nameValidationRegex = new RegExp(
  "^[\\p{L}\\p{M}]+(?:[ '\\u2019-]+[\\p{L}\\p{M}]+)*$",
  "u",
);

export const validateName = (name: string): boolean =>
  nameValidationRegex.test(name);
